var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOpinionServiceBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 254,
    viewBox: "0 0 238 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_1627)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_1627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.5254,
    y: 44.5449,
    width: 94.1685,
    height: 124.864,
    rx: 3.76345,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.9277,
    y: 99.8721,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9277,
    y: 111.45,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9277,
    y: 123.029,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9277,
    y: 134.607,
    width: 44.1163,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9988 73.0177V74.0449C53.9988 75.4066 53.9988 76.9355 53.5568 79.2408L52.0279 79.0855C52.44 77.0311 52.4579 75.5022 52.4699 74.2241H46.0676V73.0177H53.9988ZM54.9543 80.3755V81.6178H45.0404V80.3755H48.5879V76.6369H50.1048V80.3755H54.9543ZM65.5611 80.4233V81.6417H55.6113V80.4233H59.768V77.9628H61.2849V80.4233H65.5611ZM61.3327 73.4716C61.3327 75.0244 62.7302 76.6608 65.2147 77.043L64.5697 78.3091C62.6585 77.9628 61.2371 76.9415 60.5205 75.5858C59.8038 76.9355 58.3943 77.9687 56.4952 78.3091L55.8502 77.043C58.3107 76.6608 59.6963 75.0125 59.7082 73.4716V72.6952H61.3327V73.4716ZM72.3575 72.8027V74.0211H70.1955C70.2075 75.2872 70.966 76.5115 72.7039 77.0191L71.9753 78.2136C70.7748 77.8493 69.9447 77.1207 69.4669 76.183C68.9832 77.2819 68.0993 78.1539 66.7913 78.5839L66.015 77.3775C67.8186 76.8101 68.6308 75.4007 68.6547 74.0211H66.433V72.8027H72.3575ZM74.8061 72.0741V74.5944H76.2753V75.8366H74.8061V78.5241H73.2772V72.0741H74.8061ZM71.2467 78.7391C73.5042 78.7272 74.9136 79.5036 74.9136 80.8294C74.9136 82.1553 73.5042 82.9436 71.2467 82.9436C68.9414 82.9436 67.52 82.1553 67.52 80.8294C67.52 79.5036 68.9414 78.7272 71.2467 78.7391ZM71.2467 79.9217C69.8133 79.9217 69.0369 80.2203 69.0489 80.8294C69.0369 81.4506 69.8133 81.7611 71.2467 81.7611C72.6561 81.7611 73.4086 81.4506 73.4086 80.8294C73.4086 80.2203 72.6561 79.9217 71.2467 79.9217Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_1627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    y: 23.9941,
    width: 94.1685,
    height: 124.864,
    rx: 3.76345,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 79.3213,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 90.8994,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 102.479,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 114.057,
    width: 44.1163,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7886 52.2519C76.5086 52.24 77.7986 53.3628 77.7986 54.9156C77.7986 56.4803 76.5086 57.5911 74.7886 57.5911C73.0686 57.5911 71.7666 56.4803 71.7666 54.9156C71.7666 53.3628 73.0686 52.24 74.7886 52.2519ZM74.7886 53.5658C73.9286 53.5658 73.2716 54.0675 73.2836 54.9156C73.2716 55.7756 73.9286 56.2653 74.7886 56.2653C75.6486 56.2653 76.3056 55.7756 76.3175 54.9156C76.3056 54.0675 75.6606 53.5658 74.7886 53.5658ZM80.4025 51.5233V62.4167H78.8856V51.5233H80.4025ZM71.3127 58.9528C73.2478 58.9648 75.9353 58.9289 78.2645 58.6064L78.3839 59.7053C75.9711 60.1712 73.3911 60.195 71.4919 60.195L71.3127 58.9528ZM90.9854 51.5353V59.55H89.4804V57.2806H86.9959V56.0622H89.4804V54.8439H87.1512C86.3748 56.4982 84.7981 57.7225 82.6123 58.3795L81.9792 57.197C84.2964 56.4624 85.7537 55.1724 86.0284 53.5658H82.5645V52.3475H87.6887C87.6887 52.7894 87.6409 53.2194 87.5573 53.6256H89.4804V51.5353H90.9854ZM91.2721 60.9834V62.2017H83.8306V58.7498H85.3834V60.9834H91.2721ZM96.5157 53.9839C96.5157 56.0264 97.3399 58.0092 99.1554 58.7975L98.2238 60.0159C97.0174 59.4246 96.2111 58.3436 95.7632 57.0059C95.2854 58.4273 94.4493 59.5918 93.2071 60.207L92.2515 58.9648C94.1149 58.1286 94.9629 56.0264 94.9749 53.9839V52.3594H96.5157V53.9839ZM101.58 51.5233V62.4167H100.075V56.1697H97.9371V54.9395H100.075V51.5233H101.58Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_1627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.43,
    y: 78.4854,
    width: 94.1685,
    height: 124.864,
    rx: 3.76345,
    transform: "rotate(18.5895 146.43 78.4854)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 144.34,
    y: 136.156,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 144.34 136.156)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.648,
    y: 147.131,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 140.648 147.131)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.958,
    y: 158.105,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 136.958 158.105)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.267,
    y: 169.079,
    width: 44.1163,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 133.267 169.079)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.631 116.44C172.265 116.977 173.13 118.452 172.634 119.924C172.136 121.407 170.559 122.049 168.929 121.5C167.298 120.952 166.418 119.484 166.917 118.001C167.412 116.529 169.004 115.88 170.631 116.44ZM170.212 117.685C169.397 117.411 168.614 117.677 168.355 118.485C168.07 119.296 168.536 119.97 169.351 120.244C170.166 120.518 170.945 120.263 171.231 119.452C171.49 118.644 171.038 117.963 170.212 117.685ZM176.184 117.539L172.711 127.864L171.273 127.38L174.746 117.055L176.184 117.539ZM165.2 121.683C167.03 122.311 169.589 123.134 171.899 123.571L171.662 124.65C169.227 124.323 166.774 123.523 164.974 122.918L165.2 121.683ZM186.211 120.924L183.656 128.52L182.229 128.041L182.953 125.89L180.598 125.098L180.986 123.943L183.341 124.735L183.73 123.58L181.522 122.838C180.259 124.158 178.374 124.816 176.093 124.742L175.87 123.419C178.3 123.462 180.093 122.703 180.865 121.268L177.582 120.164L177.97 119.009L182.827 120.643C182.686 121.062 182.504 121.454 182.295 121.812L184.118 122.425L184.784 120.444L186.211 120.924ZM183.471 129.97L183.082 131.125L176.029 128.753L177.129 125.481L178.601 125.976L177.889 128.093L183.471 129.97ZM190.672 125.008C190.021 126.944 190.17 129.086 191.64 130.412L190.368 131.269C189.413 130.324 188.994 129.043 188.995 127.632C188.089 128.827 186.926 129.664 185.552 129.851L185.042 128.369C187.075 128.171 188.549 126.449 189.212 124.516L189.729 122.977L191.19 123.468L190.672 125.008ZM196.257 124.29L192.784 134.615L191.358 134.135L193.349 128.214L191.322 127.533L191.715 126.367L193.741 127.048L194.83 123.81L196.257 124.29Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3447,
    y: 212.218,
    width: 8.01823,
    height: 50.6459,
    transform: "rotate(-35 66.3447 212.218)",
    fill: "#1F2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9635 203.258L72.9136 207.605L66.3295 212.216L64.9635 203.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.317 184.306L128.255 183.173L135.407 233.312L127.47 234.444L120.317 184.306Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.136 175.691L128.262 183.163L120.304 184.299L123.136 175.691Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_1627",
    x: 13.5254,
    y: 44.5449,
    width: 101.696,
    height: 132.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.76345,
    dy: 3.76345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_1627",
    x: 39.75,
    y: 23.9941,
    width: 101.696,
    height: 132.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.76345,
    dy: 3.76345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_1627",
    x: 107.627,
    y: 79.4873,
    width: 134.583,
    height: 153.892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.76345,
    dy: 3.76345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_1627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 254,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpinionServiceBody);
export default __webpack_public_path__ + "static/media/IcOpinionServiceBody.bac37b7bbd055ebdb1330e90bb3c656a.svg";
export { ForwardRef as ReactComponent };